import React from 'react';

import Money from '@components/Gui/Money';
import TransactionTitle from '@components/Transactions/TransactionTitle';

const ProjectSummaryTitleCell = ({ row }) => {
    const transaction = row.Transaction || row;

    return (
        <div className="transaction-left">
            <TransactionTitle transaction={transaction} />
            {row.ClientBillingInfo && <div>{row.ClientBillingInfo.CompanyName.toUpperCase()}</div>}
            {row.ExternalFee > 0 ? (
                <small>
                    MODEL FEE: <Money amount={row.ExternalFee} currency={row.Currency} />
                </small>
            ) : null}
        </div>
    );
};

export default ProjectSummaryTitleCell;
